import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { PaneComponent } from '@rocksoft/cdk';
import { OperationsFlags } from '@rocksoft/security-sdk';

// Combined interface for Group and GroupOfUser to let the type checking work.
export interface GroupItem {
  id?: string;
  displayName?: string;
  defaultOperations?: Set<OperationsFlags>;
  parentId?: string;
  name?: string;
  userId?: string;
  inherited?: boolean;
}

@Component({
  selector: 'era-security-list-group-items-ui',
  templateUrl: './list-group-items.component.html',
  styleUrls: ['./list-group-items.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PaneComponent, FaIconComponent],
})
export class ListGroupItemsComponent {
  public readonly groups = input<GroupItem[]>();
  public readonly isEditing = input(false);
  public readonly deleteEvent = output<GroupItem>();

  delete(group: GroupItem) {
    this.deleteEvent.emit(group);
  }
}
